import { DOCUMENT, inject } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Route, Router, RouterStateSnapshot } from '@angular/router';
import { WA_WINDOW } from '@ng-web-apis/common';
import { logRedirectGuard, RmaEmptyComponent } from '@rma/generic/util/router-utils';

export function stripCommunication(prefix = '') {
  return (a: ActivatedRoute, s: RouterStateSnapshot) => {
    const router = inject(Router);
    const window = inject(WA_WINDOW);
    const document = inject(DOCUMENT);
    const redirectTo = s.url.replace(/^\/communication/, prefix).split('?')[0];

    console.error(
      'REDIRECT GUARD | communication',
      { location: window.location.href },
      { queryParams: window.location.search },
      { referrer: document.referrer },
      { redirectTo },
    );

    const defaultOptions: NavigationExtras = { queryParamsHandling: 'merge', queryParams: a.queryParams };
    return router.createUrlTree([redirectTo], defaultOptions);
  };
}
// Remove after 2024-06-30 ( check track js for logs)
export const communicationRoutes: Route[] = [
  {
    path: '',
    redirectTo: '/monitoring/inbox',
    pathMatch: 'full',
  },
  {
    path: 'inbox',
    canActivate: [stripCommunication('monitoring')],
    canActivateChild: [stripCommunication('monitoring')],
    children: [
      {
        path: '**',
        component: RmaEmptyComponent,
      },
    ],
  },
  {
    path: 'email-preferences',
    canActivate: [logRedirectGuard('/settings/email-preferences')],
    component: RmaEmptyComponent,
  },
];
